module.exports = {
    path: '/model-builder',
    component: () => import('@mb/ModelBuilder'),
    meta: { module: 'mb' },
    children: [
        {
            path: 'dce',
            name: 'dce',
            component: () => import('@mb/components/DCE')
        },
        {
            path: 'dcam',
            name: 'dcam',
            component: () => import('@mb/components/DCE')
        },
        {
            path: 'settings',
            name: 'settings',
            component: () => import('@mb/components/CustomerSettings')
        },
        {
            path: 'software-downloads',
            name: 'software-downloads',
            component: () => import('@mb/components/software-downloads'),
        },
        {
            path: 'clp',
            alias: '',
            name: 'clp',
            component: () => import('@mb/components/CLP'),
        },
        {
            path: 'clp/:customerId/jobs/:jobId/logs',
            name: 'clp-logs',
            component: () => import('@mb/components/LogViewer'),
        },
        {
            path: 'clp/:customerId/jobs/:jobId/logExports',
            name: 'clp-log-exports',
            component: () => import('@mb/components/LogExports'),
        },
        {
            path: 'clp/:customerId/jobs/new',
            name: 'clp-new-job',
            component: () => import('@mb/components/CLPNewJob'),
        },
        {
            path: 'clp/:customerId/jobs/:jobId',
            name: 'clp-job',
            component: () => import('@mb/components/CLPJob'),
        }
    ]
};



// WEBPACK FOOTER //
// ./src/modules/model-builder/router.js